
import {
  Component, Prop, Watch, Mixins
} from 'vue-property-decorator';

import FeedbackUser from '@/components/FeedbackUser/index.vue';
import PrintRedactionSheet from '@/components/Redaction/PrintRedactionSheet/PrintRedactionSheet.vue';

import ThemeWeekLoading from './ThemeWeekLoading.vue';

import RedactionService from '@/services/Redaction/RedactionService';

import openInstructionRedaction from '@/mixins/openInstructionRedaction';

import { LIST_PLAN_ID } from '@/constant/PlansIDs';

import ActiveModal from '@/share/Util/ActiveModal';

interface Theme {
  id: number;
  title: string;
  category_id?: number;
  content?: string;
}

@Component({
  components: {
    FeedbackUser,
    PrintRedactionSheet,
    ThemeWeekLoading
  }
})
export default class ThemeWeek extends Mixins(openInstructionRedaction) {
  @Prop({ default: 0 }) quantityCredits!: number;
  @Prop({ default: true }) isPermission!: boolean;

  private isLoadingThemeWeek = false;
  private themeWeek: Theme | null = null;

  private RedactionService = new RedactionService();

  private setModal = new ActiveModal();

  created() {
    this.getThemeWeek();
  }

  get message() {
    if (this.quantityCredits > 9999) {
      return this.$t('themeWeek.messages.unlimitedCredits');
    }

    if (this.quantityCredits > 0) {
      const creditName = this.quantityCredits === 1
        ? this.$t('themeWeek.credits.singular')
        : this.$t('themeWeek.credits.plural');

      return this.$t('themeWeek.messages.withCredits', {
        credits: this.quantityCredits || 0,
        creditName
      });
    }

    return this.$t('themeWeek.messages.noCredits');
  }

  get themeTitle() {
    return !this.isPermission
      ? this.$t('themeWeek.messages.discoverTheme')
      : this.themeWeek?.title;
  }

  get isPlanFree() {
    return this.$store.getters.profile?.plan?.planID === LIST_PLAN_ID.FREE;
  }

  async getThemeWeek() {
    try {
      this.isLoadingThemeWeek = true;

      const response = await this.RedactionService.getThemeWeek();

      if (response) this.themeWeek = response;
    } catch (error) {
      this.$store.dispatch('Toast/setToast', {
        text: this.$t('themeWeek.errorLoading'),
        status: 'error'
      });
      console.error(error);
    } finally {
      this.isLoadingThemeWeek = false;
    }
  }

  @Watch('quantityCredits', {
    immediate: true
  })
  setCanOpenProposal() {
    if (!this.quantityCredits) {
      this.$store.commit('setCanOpenProposals', false);
    }
  }

  handleRedirectRedaction(redactionId: number, componentName: string) {
    if (!this.isPermission) {
      this.setShowModal();

      return;
    }

    this.goToInstruction(redactionId, componentName);
  }

  setShowModal() {
    if (this.isPlanFree) this.showModal('modalPlanUpdate');
    else this.showModal('modalNotContentPlan');
  }

  showModal(id: string) {
    this.setModal.activeModal(id);
  }
}
